import React from 'react';
import { ListItem } from 'material-ui/List';

import EmailTemplateIcon from 'material-ui/svg-icons/content/drafts';
import ContextIconMenu from '../Common/ContextIconMenu';

import EventActions from '../../actions/EventActionCreator';
import { statusColours } from '../../constants/ColourConstants';


const getActions = ({id}, resourceId) => [
    {
        type: 'deleteDialog',
        dialogType: 'menu',
        value: {id: resourceId, reminderId: id},
        title: 'Delete',
        deleteAction: EventActions.removeReminder,
        message: (<span>Delete this reminder?</span>),
    }
];

const ReminderListItem = ({reminder, resourceId}) => {

    return (
        <ListItem
            leftAvatar={<EmailTemplateIcon color={statusColours.default}/>}
            primaryText={reminder.template}
            secondaryText={<span>{`${reminder.number} ${reminder.unit}`}</span>}
            secondaryTextLines={1}
            rightIcon={<ContextIconMenu actions={getActions(reminder, resourceId)} />}
        />
    );
};

export default ReminderListItem;
